import React from "react";
import { IconButton, Stack } from "@mui/material";

import TwitterIcon from "../Icons/TwitterIcon";
import FacebookIcon from "../Icons/FacebookIcon";
import YoutubeIcon from "../Icons/YoutubeIcon";
import InstagramIcon from "../Icons/InstagramIcon";
import { Link } from "gatsby-plugin-react-i18next";

export default function SocialIcons() {
  return (
    <Stack direction="row" gap="16px" flexWrap="wrap">
      <IconButton href="https://www.facebook.com/crossborderxpress" target="_blank" rel="noopener noreferrer" sx={{ padding: "0" }}>
        <FacebookIcon />
      </IconButton>
      <IconButton href="https://www.instagram.com/crossborderxpress/" target="_blank" rel="noopener noreferrer" sx={{ padding: "0" }}>
        <InstagramIcon />
      </IconButton>
      <IconButton href="https://www.youtube.com/@CrossBorderXpressOfficial" target="_blank" rel="noopener noreferrer" sx={{ padding: "0" }}>
        <YoutubeIcon />
      </IconButton>
      <IconButton href="https://twitter.com/CrossBrdrXpress" target="_blank" rel="noopener noreferrer" sx={{ padding: "0" }}>
        <TwitterIcon />
      </IconButton>
    </Stack>
  );
}
